// extracted by mini-css-extract-plugin
var _1 = "_approval-module__product-settings-container";
var _2 = "_approval-module__tab-display";
var _3 = "_approval-module__title";
export { _1 as "product-settings-container", _2 as "tab-display", _3 as "title" }
